module.exports = __webpack_public_path__ + "media/images/navbar/donate_warning/Transparent-c3103ba4986952ae4d90fa4f7917d808.png";